import { DOWNLOAD_TYPE_MULTIPLE } from '~/features/deliverables/constants/DownloadFile';

export const defaultFilters = {
    context: undefined,
    // deliverableIdPrefix: '',
    releaseState: 'all',
    baseSoftwareVersion: 'all',
    downloadType: DOWNLOAD_TYPE_MULTIPLE,
    // mdmcAppVersion: '0.0.0'
};
